// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"5b84b1f0","35":"6ecfdf1b","163":"ceb271c5","212":"31f0016b","796":"a3d7d023"}[chunkId] + ".chunk.css";
};